function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Link } from 'react-router-dom';
import { Tabs, TabsPane } from '../../../Tabs';
import { Section } from '../../../Section';
import { PercentLabel } from '../../Labels';
import { Select } from '../../../Select';
import { getHomeCardsPerformance } from '../utils';
import { CardsContainer, CategoryCard, TwoColumns, CategoryTitle, SelectContainer } from './partials';
var PERIODS = [{
  period: 'W1',
  label: 'Semana'
}, {
  period: 'M1',
  label: 'Mes'
}, {
  period: 'M12',
  label: '12 meses'
}];
var CategoriesTabsHome = function (_React$Component) {
  _inherits(CategoriesTabsHome, _React$Component);
  var _super = _createSuper(CategoriesTabsHome);
  function CategoriesTabsHome() {
    var _this;
    _classCallCheck(this, CategoriesTabsHome);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      tabs: [],
      order: {
        type: 'none',
        field: null,
        ordering: 'child'
      }
    });
    _defineProperty(_assertThisInitialized(_this), "loadTabs", function () {
      var tabs = _this.props.categoriesList.map(function (tab) {
        return _objectSpread(_objectSpread({}, tab), {}, {
          categories: tab.categories.map(function (cat) {
            var performances = getHomeCardsPerformance(_this.props.categories, cat.broad || null, cat.ids || [], Boolean(cat.broad));
            var weightedPerformance = PERIODS.map(function (_ref) {
              var period = _ref.period,
                label = _ref.label;
              var allDataForPeriod = performances.map(function (fund) {
                return fund.performance.find(function (perf) {
                  return perf.period === period;
                }).value;
              });
              var weights = performances.map(function (fund) {
                return fund.funds;
              });
              var total = weights.reduce(function (acc, val) {
                return acc + val;
              }, 0);
              var weighted = allDataForPeriod.map(function (data, index) {
                return data * (weights[index] / total);
              });
              var weightedSum = weighted.reduce(function (acc, val) {
                return acc + val;
              }, 0);
              return {
                period: period,
                label: label,
                value: weightedSum,
                component: React.createElement(PercentLabel, {
                  withPositiveSign: true,
                  withSparkline: true,
                  value: weightedSum
                })
              };
            });
            return _objectSpread(_objectSpread({}, cat), {}, {
              selected: 'W1',
              performance: weightedPerformance
            });
          })
        });
      });
      _this.setState({
        tabs: tabs
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSelectChange", function (event) {
      var newTabs = _this.state.tabs.map(function (tab) {
        return _objectSpread(_objectSpread({}, tab), {}, {
          categories: tab.categories.map(function (cat) {
            return _objectSpread(_objectSpread({}, cat), {}, {
              selected: event.cat === cat.title ? event.id : cat.selected
            });
          })
        });
      });
      _this.setState({
        tabs: newTabs
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleOrderChange", function (order) {
      _this.setState({
        order: order
      });
    });
    return _this;
  }
  _createClass(CategoriesTabsHome, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.categories.length) this.loadTabs();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.categories.length && this.props.categories.length) this.loadTabs();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var tabs = this.state.tabs;
      return React.createElement(Section, {
        title: "Panel de rentabilidades",
        bottomMargin: true,
        link: {
          text: "Ver todos",
          href: "/".concat(this.props.productSlug, "/categoria/todos"),
          type: 'client'
        }
      }, React.createElement(Tabs, {
        variant: "chips",
        titleColor: "primary"
      }, tabs.map(function (tab, key) {
        return React.createElement(TabsPane, {
          key: key,
          title: tab.tab
        }, React.createElement(CardsContainer, null, tab.categories.map(function (cat, key2) {
          var selected = cat.performance.find(function (per) {
            return per.period === cat.selected;
          });
          return React.createElement(CategoryCard, {
            key: key2
          }, React.createElement(TwoColumns, null, React.createElement(AppLink, {
            as: Link,
            to: "/".concat(_this2.props.productSlug, "/categoria/").concat(cat.to ? cat.to : tab.to),
            title: "Ver todas las categor\xEDas de ".concat(cat.to ? cat.title : tab.tab)
          }, React.createElement(CategoryTitle, null, cat.title)), React.createElement(SelectContainer, null, selected && selected.component, React.createElement(Select, {
            selected: cat.selected,
            color: "terciary",
            chevronColor: "primary",
            options: PERIODS.map(function (_ref2) {
              var period = _ref2.period;
              var performance = cat.performance.find(function (per) {
                return per.period === period;
              });
              return {
                id: period,
                label: performance ? performance.label : null
              };
            }),
            onChange: function onChange(event) {
              _this2.handleSelectChange(_objectSpread(_objectSpread({}, event), {}, {
                cat: cat.title
              }));
            },
            optionsDisplay: "flex",
            withBorder: false,
            withPadding: false
          }))));
        })));
      })));
    }
  }]);
  return CategoriesTabsHome;
}(React.Component);
export default CategoriesTabsHome;